// DS: MO3.4.5
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import BuyButton from '@wix/da-ds/pkg/Buttons/BuyButton';
import DeviationShopCard, {
  type DeviationShopCardProps,
} from '../DeviationShopCard';

interface Props extends Omit<DeviationShopCardProps, 'detailsRightSlot'> {}

const SellPromotionCard: React.FC<Props> = ({ deviation, ...rest }) => {
  const { t } = useTranslation();
  return (
    <DeviationShopCard
      deviation={deviation}
      extraBiData={{ sectionname: 'Start earning' }}
      detailsRightSlot={
        <BuyButton
          size="large"
          rounded
          href={Url.deviationLink(deviation.deviationId)}
        >
          {t('common.sell')}
        </BuyButton>
      }
      {...rest}
    />
  );
};

SellPromotionCard.displayName = 'SellPromotionCard';

export default SellPromotionCard;
